import base from '../base';
import { getRequest, postJsonRequest, postRequest } from '@/util/http';

const MCHCHAN = {
  // 根据id查询
  getMchchan(params) {
    return getRequest(`${base.baseUrl}/mchchan/getMchChans`, params);
  },
  // 设置微信JSAPI 支付参数
  addMchchan(params) {
    return postJsonRequest(`${base.baseUrl}/mchchan/add_mch_chan`, params);
  },
  // 设置汇付宝支付参数
  addHeepay(params) {
    return postJsonRequest(`${base.baseUrl}/third_party_relation/save`, params);
  },
  // 获取已开通渠道详情
  getDetail(params) {
    return postRequest(`${base.baseUrl}/mchchan/getById`, params);
  },
  // 修改支付参数
  updateMchchan(params) {
    return postJsonRequest(`${base.baseUrl}/mchchan/update`, params);
  },
  // 获取汇付宝主商户信息
  getMerchantInfo(params) {
    return getRequest(`${base.baseUrl}/third_party_relation/get_info`, params);
  },
  // 新增分账绑定关系
  saveRelation(params) {
    return postJsonRequest(`${base.baseUrl}/bind/save`, params);
  },
  //获取绑定关系列表 
  getBinds(params) {
    return postJsonRequest(`${base.baseUrl}/bind/getBinds`, params);
  },
  //修改绑定关系
  updateRelation(params) {
    return postJsonRequest(`${base.baseUrl}/bind/update`, params);
  },
  //删除绑定关系
  deleteBind(params) {
    return postJsonRequest(`${base.baseUrl}/bind/deleteBind`, params);
  },
  //获取绑定关系详情
  getBindInfo(params) {
    return getRequest(`${base.baseUrl}/bind/get_bind_info`, params);
  },
  //添加分账规则
  saveRules(params) {
    return postJsonRequest(`${base.baseUrl}/rules/save`, params);
  },
  // 获取绑定商户列表
  getBindList(params) {
    return getRequest(`${base.baseUrl}/bind/get_bind_list`, params);
  },
  // 获取分账规则
  getRulesAll(params) {
    return getRequest(`${base.baseUrl}/rules/query_rules_all`, params);
  }, 
  // 删除分账规则
  deleteRule(params) {
    return postJsonRequest(`${base.baseUrl}/rules/delete`, params);
  }, 
  // 启用分账规则  
  startRule(params) {
    return postJsonRequest(`${base.baseUrl}/rules/start`, params);
  }, 
  // 分账规则详情  
  queryRule(params) {
    return getRequest(`${base.baseUrl}/rules/query_rules`, params);
  },
  // 修改分账规则  
  updateRule(params) {
    return postJsonRequest(`${base.baseUrl}/rules/update`, params);
  },
  // 修改汇付宝渠道
  editHeepay(params) {
    return postJsonRequest(`${base.baseUrl}/third_party_relation/update`, params);
  },
};

export default MCHCHAN;
